/* Detail.jsx */
import React, {useRef} from 'react'
// Components
import Header from '../Components/Header'
// CSS
import styled from 'styled-components'
// FB
import {addMemeFB} from "../Redux/modules/words";
import {useDispatch} from "react-redux";

import '../Components/GlobalStyled/font.css'

const Detail = () => {
  const onPage = false;
  const dispatch = useDispatch();

  const nameRef = useRef();
  const descRef = useRef();
  const urlRef = useRef();
  const pwRef = useRef();

  const addMemeList = (event) => {
    //dispatch(createBucket(text.current.value));
    dispatch(addMemeFB({ name: nameRef.current.value, desc: descRef.current.value, url: urlRef.current.value, pw: pwRef.current.value }));
    nameRef.current.value ="";
    descRef.current.value ="";
    urlRef.current.value ="";
    event.preventDefault();
    alert('밈이 추가되었다!')
  };

  return (
    <>
        <Header onPage={onPage}/>
        <Wrap>
          <Grid>
            <IMG src="https://bunny.jjalbot.com/2016/10/r1WMyt6IC/88_55169dca4c601_1423.jpg" alt="" />
            <IMG src="https://i.pinimg.com/originals/32/64/8c/32648ccb94bb0ff7874cbe9c2f20b3bb.gif" alt="" />
            <IMG src="https://i.pinimg.com/originals/0c/64/9a/0c649a17ec1e5f5ca340248b4ef4e4be.gif" alt="" />
            <IMG src="https://keyhole.co/wp-content/uploads/2019/11/3fdkbz.gif" alt="" />
            <IMG src="https://media3.giphy.com/media/XBieBakVVSo4fOD9TU/200.gif" alt="" />
            <IMG src="https://media0.giphy.com/media/VRKheDy4DkBMrQm66p/giphy-downsized-large.gif" alt="" />
          </Grid>
          <Container onSubmit={addMemeList}>
              <input type="text" placeholder="밈 이름" ref={nameRef} required maxLength={8}/>
              <input type="text" placeholder="설명" ref={descRef} required maxLength={20}/>
              <input type="text" placeholder="사진 URL" ref={urlRef} required/>
              <input type="password" placeholder="비밀번호 4자리" ref={pwRef} required minLength={4} maxLength={4}/>
              <button >
              <span></span>
              <span></span>
              <span></span>
              <span></span>
                추가하기
              </button>
          </Container>
          <Grid>
            <IMG src="https://play-lh.googleusercontent.com/PLyDnDmyjdWhcmi-aCZ8n48nbb21-FTMxl0Lq3rrjfRiRqDxmfYBQtophFdHQkOIcQ=w526-h296-rw" alt="" />
            <IMG src="https://c.tenor.com/cejAWVmIulsAAAAd/%ED%98%B8%EB%B0%95%EA%B3%A0%EA%B5%AC%EB%A7%88-%EC%A7%80%EB%B6%95%EB%9A%AB%EA%B3%A0%ED%95%98%EC%9D%B4%ED%82%A5.gif" alt="" />
            <IMG src="https://i.pinimg.com/originals/5b/d6/8c/5bd68c6d04eb8a54e0bab9380b46db3b.png" alt="" />
            <IMG src="https://mblogthumb-phinf.pstatic.net/MjAxOTA0MTFfMTU0/MDAxNTU0OTE2MTgxMjU1.wiIdy5YQWIRRI3uYwIjOQq0s7r0OMqKAZW6vjf3xCd8g.Ejy7adIC84d3A4Rh14_w8yhyzsOYmtXkEU4YVkNJQMYg.JPEG.jubbigi/%EA%B0%95%EC%95%84%EC%A7%80%EC%A7%A41.jpg?type=w800" alt="" />
            <IMG src="https://i.pinimg.com/originals/86/a9/c3/86a9c3eef30f3cc8e3d2753b448a87e5.gif" alt="" />
            <IMG src="https://golden-goblin.com/content-thief/wp-content/uploads/sites/5/kboard_attached/1/202006/5ed8e0d37033f5013918.gif" alt="" />
          </Grid>
        </Wrap>
    </>
  )
}

export default Detail

const Wrap = styled.div`
  display: flex;
  justify-content: center;
  align-items:center;
`;

const IMG = styled.img`
  width: 200px;
  height: 200px;
`;
const Grid = styled.div`
  display: grid;
  grid-template-columns: 200px 200px;
  grid-template-rows: 200px 200px;
  margin-top: 50px;
  @media screen and (max-width: 1150px) {
    display: none;
  }
`;

const Container = styled.form`
  margin-top: 50px;
  width: 50%;
  height: 600px;
  border: 1px solid white;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  @media screen and (max-width:800px) {
    width:100%;
  }
  input{
    font-size: 50px;
    width: 80%;
    height: 100px;
    text-align: center;
    font-family: 'Akaya Telivigala', cursive;
    @media screen and (max-width:800px) {
      width:30%;
    }
  }
  button {
    width: 50%;
    position: relative;
    display: inline-block;
    padding: 15px 30px;
    color: #fff;
    text-transform: uppercase;
    letter-spacing: 4px;
    text-decoration: none;
    font-size: 50px;
    overflow: hidden;
    transition: 0.2s;
    background-color: transparent;
    border: none;
    border-radius: 5px;
    font-family: 'Akaya Telivigala', cursive;
}
button:hover {
    color: #000;
    background: #fff;
    box-shadow: 0 0 10px #fff, 0 0 40px #fff, 0 0 80px #fff;
    transition-delay: 1s;
}

button span {
    position: absolute;
    display: block;
}


button span:nth-child(1) {
    top: 0;
    left: -100%;
    width: 100%;
    height: 2px;
    background: linear-gradient(90deg, transparent, #fff);
}

button:hover span:nth-child(1) {
    left: 100%;
    transition: 0.5s;
}

button span:nth-child(3) {
    bottom: 0;
    right: -100%;
    width: 100%;
    height: 2px;
    background: linear-gradient(270deg, transparent, #fff);
}

button:hover span:nth-child(3) {
    right: 100%;
    transition: 0.5s;
    transition-delay: 0.5s;
}

button span:nth-child(2) {
    top: -100%;
    right: 0;
    width: 2px;
    height: 100%;
    background: linear-gradient(180deg, transparent, #fff);
}

button:hover span:nth-child(2) {
    top: 100%;
    transition: 0.5s;
    transition-delay: 0.25s;
}

button span:nth-child(4) {
    bottom: -100%;
    left: 0;
    width: 2px;
    height: 100%;
    background: linear-gradient(360deg, transparent, #fff);
}

button:hover span:nth-child(4) {
    bottom: 100%;
    transition: 0.5s;
    transition-delay: 0.75s;
}
`;